import {ProductSizeCode} from "../types/types";

const fixed = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', 'OS', 'XS-S', 'S-M', 'M-L', 'L-XL',];

export const sortedSizes = (sizes: string[]) => {
    const sorted = sizes.sort((a, b) => {
        const indexA = fixed.indexOf(a) ;
        const indexB = fixed.indexOf(b);
        return indexA - indexB;
    });
    return sorted;
}

export const sortedSizeObjects = (list: any[], target: string) => {
    let sorted = list;
    // @ts-ignore
    sorted?.sort((a, b) => {
        if (a.sizeName > b.sizeName) return 1;
        if (a.sizeName < b.sizeName) return -1;
        if (a.sizeName === b.sizeName) return 0;
    });
    sorted?.sort((a, b) => {
        const indexA = fixed.indexOf(a[target]) ;
        const indexB = fixed.indexOf(b[target]);
        return indexA - indexB;
    });
    return sorted;
}

export const sortedSizeFilter = (list: ProductSizeCode[]) => {
    let sorted = list;
    // @ts-ignore
    sorted.sort((a, b) => {
        if (a.sizeClassCode > b.sizeClassCode) return 1;
        if (a.sizeClassCode < b.sizeClassCode) return -1;
        if (a.sizeClassCode === b.sizeClassCode) return 0;
    });
    sorted.sort((a, b) => {
        const indexA = fixed.indexOf(a.sizeName);
        const indexB = fixed.indexOf(b.sizeName);
        return indexA - indexB;
    });
    // 전체 카테고리 선택시 중복제거가 되어야 해서 임시로 추가함
    const filteredList = sorted.filter((item, index) => sorted.findIndex(ntem => ntem.sizeName === item.sizeName) === index);
    return filteredList;
}